module.exports = __webpack_public_path__ + "static/img/bushes-after.a3b2b2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/bushes-after.png
// module id = 649
// module chunks = 64